import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Lock, Menu, X, LogOut, User, MessageCircle, Building2 } from 'lucide-react';
import Logo from './Logo';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';

const Header = () => {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const links = [
    { to: '/', label: 'Início' },
    { to: '/sobre-nos', label: 'Sobre Nós' },
    { to: '/para-empresas', label: 'Para Empresas' },
    { to: '/para-candidatos', label: 'Para Candidatos' },
    { to: '/conteudos', label: 'Conteúdos' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-orange-100 shadow-sm">
      <div className="container-hm px-4 md:px-8 flex items-center justify-between h-20">
        <Logo />

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === '/'} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/contato" className="btn-hm !py-2.5 !px-5 !text-sm">
            <MessageCircle className="w-4 h-4" /> Contato
          </Link>
          {user ? (
            <>
              <Link to={user.role === 'candidate' ? '/portal/candidato' : '/portal/admin'} className="flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-hm-orange">
                <User className="w-4 h-4" />
                {user.name?.split(' ')[0] || 'Conta'}
              </Link>
              <Button variant="outline" size="sm" onClick={handleLogout} className="rounded-full">
                <LogOut className="w-4 h-4 mr-1" /> Sair
              </Button>
            </>
          ) : (
            <>
              <Link to="/portal/candidato/login" data-testid="header-portal-candidato" className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 hover:text-hm-orange transition-colors">
                <Lock className="w-3.5 h-3.5" /> Portal do Candidato
              </Link>
              <Link to="/portal/empresa/login" data-testid="header-portal-empresa" className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 hover:text-hm-orange transition-colors">
                <Building2 className="w-3.5 h-3.5" /> Portal da Empresa
              </Link>
            </>
          )}
        </div>

        <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-slate-700" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-orange-100 bg-white shadow-lg">
          <div className="container-hm px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === '/'} onClick={() => setOpen(false)} className={({ isActive }) => `py-2.5 px-3 rounded-lg text-base font-medium ${isActive ? 'text-white bg-hm-orange' : 'text-slate-700 hover:bg-orange-50'}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contato" onClick={() => setOpen(false)} className="btn-hm mt-2">
              <MessageCircle className="w-4 h-4" /> Contato
            </Link>
            <div className="h-px bg-orange-100 my-2" />
            {user ? (
              <>
                <Link to={user.role === 'candidate' ? '/portal/candidato' : '/portal/admin'} onClick={() => setOpen(false)} className="py-2.5 px-3 rounded-lg text-base font-medium text-slate-700 hover:bg-orange-50">Meu painel</Link>
                <button onClick={() => { handleLogout(); setOpen(false); }} className="text-left py-2.5 px-3 rounded-lg text-base font-medium text-red-600 hover:bg-red-50">Sair</button>
              </>
            ) : (
              <>
                <Link to="/portal/candidato/login" data-testid="header-portal-candidato-mobile" onClick={() => setOpen(false)} className="flex items-center gap-2 py-2.5 px-3 rounded-lg text-base font-medium text-slate-700 hover:bg-orange-50"><Lock className="w-4 h-4 text-hm-orange" /> Portal do Candidato</Link>
                <Link to="/portal/empresa/login" data-testid="header-portal-empresa-mobile" onClick={() => setOpen(false)} className="flex items-center gap-2 py-2.5 px-3 rounded-lg text-base font-medium text-slate-700 hover:bg-orange-50"><Building2 className="w-4 h-4 text-hm-orange" /> Portal da Empresa</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
